'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _CloudinaryImage = require('web-makeup/dist/CloudinaryImage');

var _CloudinaryImage2 = _interopRequireDefault(_CloudinaryImage);

var _typography = require('web-makeup/dist/design-system/styles/typography');

var _spacings = require('web-makeup/dist/design-system/styles/spacings');

var _navigationBarStyles = require('../../../config/data/navigation-bar-styles');

var _pageFooter = require('./page-footer.style');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentOptions = function PaymentOptions() {
    return _react2.default.createElement(_pageFooter.PaymentBox, null, _react2.default.createElement(_spacings.Margin, { top: true, bottom: true, size: "xxSmall" }, _react2.default.createElement(_typography.Text, { as: "span", fontSize: "h5", fontWeight: "bold", color: "white", lineHeight: "big" }, "We support")), _react2.default.createElement(_pageFooter.CreditCard, { useSourceFormat: true, source: { id: 'v1/-homepage-icons/-footer/badges-cards.svg', type: 'upload' } }));
};
var AppStoreLogos = function AppStoreLogos() {
    return _react2.default.createElement(_pageFooter.AppsWrapper, null, _react2.default.createElement(_spacings.Margin, { top: true, bottom: true, size: "xxSmall" }, _react2.default.createElement(_typography.Text, { as: "span", fontSize: "h5", fontWeight: "bold", color: "white" }, "Discover us on")), _react2.default.createElement("span", null, _react2.default.createElement(_pageFooter.ApplicationLink, { href: "https://apps.apple.com/us/app/90-seconds/id729925714", target: "_blank" }, _react2.default.createElement(_pageFooter.AppStoreLogo, { useSourceFormat: true, source: {
            id: 'v1600776066/app-store-badge.svg',
            type: 'upload'
        } })), _react2.default.createElement(_pageFooter.ApplicationLink, { href: "https://play.google.com/store/apps/details?id=com.ninetyseconds.auckland.creators", target: "_blank" }, _react2.default.createElement(_pageFooter.AppStoreLogo, { useSourceFormat: true, source: {
            id: 'v1600776066/google-play-badge.svg',
            type: 'upload'
        } }))));
};
var PageFooter = function PageFooter() {
    var logo = _navigationBarStyles.theme.logos.platform;
    return _react2.default.createElement(_react2.default.Fragment, null, _react2.default.createElement(_pageFooter.FooterTop, null, _react2.default.createElement(_pageFooter.FooterTopWrapper, null, _react2.default.createElement(_antd.Row, { type: "flex" }, _config.footerSections.map(function (_a) {
        var columnTitle = _a.columnTitle,
            items = _a.items;
        return _react2.default.createElement(_pageFooter.StyledCol, { key: columnTitle, xs: 24, sm: 12, md: 12, lg: 6 }, _react2.default.createElement(_pageFooter.FooterItem, { as: "div", fontSize: "h4", color: "white", fontWeight: "black" }, columnTitle), items.map(function (item, index) {
            return item.link && item.external ? _react2.default.createElement(_pageFooter.FooterItem, { key: index, as: "a", color: "white", fontSize: "h5", lineHeight: "big", href: item.link, target: "_blank" }, item.title) : _react2.default.createElement(_pageFooter.FooterItem, { key: index, as: "a", color: "white", fontSize: "h5", lineHeight: "big", href: item.link }, item.title);
        }));
    })))), _react2.default.createElement(_pageFooter.FooterContent, null, _react2.default.createElement(_pageFooter.FooterContentWrapper, null, _react2.default.createElement(_pageFooter.FooterContentLogo, null, _react2.default.createElement(_CloudinaryImage2.default, { source: {
            id: logo,
            type: 'upload'
        }, useSourceFormat: true })), _react2.default.createElement(AppStoreLogos, null), _react2.default.createElement(PaymentOptions, null))), _react2.default.createElement(_pageFooter.FooterBottom, null, _react2.default.createElement(_pageFooter.FooterBottomWrapper, null, _react2.default.createElement(_typography.Text, { as: "div", fontSize: "h6", color: "white" }, 'Copyright \xA9 2020 90 Seconds. All rights reserved.'), _react2.default.createElement("div", null, _config.socialMediaLinks.map(function (_a) {
        var iconId = _a.iconId,
            url = _a.url;
        return _react2.default.createElement(_pageFooter.SocialLink, { href: url, key: iconId, target: "blank" }, _react2.default.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: { id: "-homepage-icons/-footer/" + iconId, type: 'upload' } }));
    })), _react2.default.createElement("div", null, _react2.default.createElement(_CloudinaryImage2.default, { useSourceFormat: true, source: {
            id: 'v1569485721/-homepage-icons/-footer/icon-pin-white.svg',
            type: 'upload'
        }, sizes: _config.customImageSizes }), _react2.default.createElement(_typography.Text, { as: "span", fontSize: "h6", color: "white" }, _react2.default.createElement("strong", null, "HQ: "), " 158 Cecil Street #03-01, S069545, Singapore")))));
};
exports.default = PageFooter;
//# sourceMappingURL=page-footer.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/components/page-footer/page-footer.js
// module id = 1923
// module chunks = 0